import { apiFetch, apiRequest, publicApiFetch } from './client';
export async function createStudyShare(studyId, request) {
    return apiRequest('POST', `/study/${encodeURIComponent(studyId)}/share`, request ?? {});
}
export async function getStudyShares(studyId) {
    return apiFetch(`/study/${encodeURIComponent(studyId)}/shares`);
}
export async function revokeStudyShare(shareId) {
    return apiRequest('DELETE', `/share/${encodeURIComponent(shareId)}`);
}
// `region` is the share URL's `r` hint — the only region signal on the public
// share route (no JWT), without which resolution falls back to the first
// configured region and 404s for shares hosted elsewhere.
export async function getSharedStudy(token, region) {
    return publicApiFetch(`/share/${encodeURIComponent(token)}`, {}, region);
}
/** Sent share-emails for a study (one row per recipient), newest first. */
export async function getStudyEmailLogs(studyId) {
    return apiFetch(`/study/${encodeURIComponent(studyId)}/email-logs`);
}
/** Full detail (incl. rendered HTML body) of a single sent share-email. */
export async function getStudyEmailLog(studyId, logId) {
    return apiFetch(`/study/${encodeURIComponent(studyId)}/email-logs/${encodeURIComponent(logId)}`);
}
